import * as React from "react";
import type { BaseIconProps } from "../../Icon.types";

export function FleetIcon({ size = 18, color, strokeColor, fillColor, className }: BaseIconProps) {
  const stroke = strokeColor ?? color ?? "currentColor";
  const fill = fillColor ?? "none";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className={className}
    >
      <path d="M5.5 1L10 5v5H1V5z" />
      <path d="M17.5 1L22 5v5H13V5z" />
      <path d="M5.5 13L10 17v5H1V17z" />
      <path d="M17.5 13L22 17v5H13V17z" />
    </svg>
  );
}
